<template>
  <v-layout row wrap>
    <v-flex xs12>
      <Navbar />
    </v-flex>
    <responsive-flex>
      <CreditFormPageTwo
        :customerData="coapplicantData"
        :lenderName="lender.id"
        @submit="submitFunction(...arguments)"
      />
      <v-flex xs12
        v-if="lender.id === 'greensky'"
        class="px-3 pt-2 text-xs-left caption"
      >
        <div
          class="full-width"
          v-html="greenskyMainFooter"
        />
      </v-flex>
    </responsive-flex>
  </v-layout>
</template>

<script>
  import Navbar from 'Components/Navbar.vue'
  import CreditFormPageTwo from 'Components/CreditFormPageTwo.vue'
  import { mapState, mapActions } from 'vuex'
  import ResponsiveFlex from 'Components/ResponsiveFlex.vue'
    import { greenskyFooter } from 'Helpers/CreditApplicationFormHelper.js'

  export default {
    name: 'CoapplicantFormPageTwo',
    components: {
      CreditFormPageTwo,
      Navbar,
      ResponsiveFlex,
    },
    data () {
      return {
        backPath: '/credit-application/coapplicant-page-one',
        coapplicantText: 'Please check this box if you wish to apply with a Co-Applicant',
        greenskyMainFooter: '',
      }
    },
    computed: {
      ...mapState({
        coapplicantData: state => state.loanApplication.coapplicantData,
        lender: state => state.loanApplication.lender
      })
    },
    methods: {
      ...mapActions([
        'setCoapplicantData',
        'getGreenskyLegalContent'
      ]),
      submitFunction (newData) {
        this.setCoapplicantData(newData)
        this.$router.push({
          path: '/credit-application/review-application'
        })
      },
    },
    async mounted() {
      if (this.lender.id === 'greensky'){
        this.greenskyMainFooter = await this.getGreenskyLegalContent(greenskyFooter)
      } else {
        this.greenskyMainFooter = greenskyFooter()
      }
    },
    created () {
      if (!this.coapplicantData.firstName) {
        this.$router.push({
          path: '/credit-application/coapplicant-page-one'
        })
      }
    }
  }
</script>
